//src/styles/custom/shadows.js

import palette from "../palette";

const shadows = {
  light: `0 2px 4px ${palette.primary?.alpha?.['10'] || "rgba(0,0,0,0.1)"}`,
  medium: `0 4px 8px ${palette.primary?.alpha?.['15'] || "rgba(0,0,0,0.15)"}`,
  heavy: `0 8px 16px ${palette.primary?.alpha?.['20'] || "rgba(0,0,0,0.2)"}`,
  hover: `0 12px 24px ${palette.primary?.alpha?.['25'] || "rgba(0,0,0,0.25)"}`,
};

export default shadows;